import React from "react";
import { motion } from "framer-motion";

const ThemedButton = ({ onClick, children, className = "", ...props }) => {
  return (
    <motion.button
      whileTap={{ scale: 0.96 }}
      whileHover={{ y: -2 }}
      onClick={onClick}
      {...props}
      className={`
        relative group
        inline-flex items-center justify-center gap-2
        px-8 py-4
        rounded-xl font-semibold
        text-base sm:text-lg
        transition-all duration-300
        focus:outline-none focus:ring-2 focus:ring-lime-400/60

        /* Light mode */
        bg-gradient-to-r from-blue-600 via-blue-500 to-indigo-600
        text-white
        shadow-[0_12px_30px_rgba(37,99,235,0.35)]
        hover:shadow-[0_20px_50px_rgba(37,99,235,0.55)]

        /* Dark mode */
        dark:bg-gradient-to-r dark:from-lime-400 dark:via-lime-500 dark:to-green-500
        dark:text-black
        dark:shadow-[0_0_40px_rgba(132,204,22,0.5)]
        dark:hover:shadow-[0_0_70px_rgba(132,204,22,0.8)]

        ${className}
      `}
    >
      {/* Glow layer */}
      <span
        className="
          pointer-events-none absolute inset-0 rounded-xl
          bg-gradient-to-r from-white/10 via-white/20 to-white/10
          opacity-0 group-hover:opacity-100
          transition-opacity duration-300
        "
      />

      <span className="relative z-10 flex items-center gap-2">
        {children}
      </span>
    </motion.button>
  );
};

export default ThemedButton;

